import _ from 'lodash'

const boundaryChargeableDuration = (durationInMinutes, billingDetails) => {
  if (durationInMinutes < billingDetails.minimum_time || billingDetails.minimum_time === 0) {
    return 0
  }
  if (durationInMinutes === billingDetails.minimum_time) { return durationInMinutes }

  return _.ceil(_.toNumber(durationInMinutes) / billingDetails.round_by) * billingDetails.round_by
}

const roundChargeableDuration = (durationInMinutes, billingDetails) => {
  if (billingDetails.minimum_time === 0) { return 0 }
  if (durationInMinutes <= billingDetails.minimum_time) { return billingDetails.minimum_time }

  return _.ceil(_.toNumber(durationInMinutes) / billingDetails.round_by) * billingDetails.round_by
}

const findChargeableDuration = (durationInHours, billingDetails) => {
  if (_.isNil(billingDetails)) { return durationInHours }
  if (billingDetails.minimum_time === 0) { return 0 }

  if (billingDetails.type === 'WorkTypeBillingDetails::Round') {
    return roundChargeableDuration(durationInHours * 60, billingDetails) / 60
  }
  if (billingDetails.type === 'WorkTypeBillingDetails::Boundary') {
    return boundaryChargeableDuration(durationInHours * 60, billingDetails) / 60
  }
  if (billingDetails.type === 'WorkTypeBillingDetails::Fixed') {
    return billingDetails.minimum_time / 60
  }
}

const minutesToHours = (duration) => {
  const hours = Math.floor(duration / 60)
  const minutes = _.round(duration % 60)

  return {
    hours: _.padStart(hours, 2, 0),
    minutes: _.padStart(minutes, 2, 0)
  }
}

const minutesToHumanFormat = (duration) => {
  const { hours, minutes } = minutesToHours(duration)

  return `${hours}:${minutes}`
}

const timesheetDuration = (timesheet) => {
  const endTimeMinutes = new Date(timesheet.end_time).getMinutes()
  const startTimeMinutes = new Date(timesheet.start_time).getMinutes()

  const endTime = new Date(timesheet.end_time).setMinutes(endTimeMinutes, 0, 0)
  const startTime = new Date(timesheet.start_time).setMinutes(startTimeMinutes, 0, 0)

  return (new Date(endTime).getTime() - new Date(startTime).getTime()) / (1000 * 3600)
}

export {
  findChargeableDuration,
  minutesToHours,
  minutesToHumanFormat,
  timesheetDuration
}
